// pages/index.js
// For SSR
// pages/index.js
export { default, getStaticProps } from './[...path]';

// For SSG
// export { default, getStaticProps } from './[...path]';
